import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import userAgent from "./userAgent";
import poiReducers from "../../pois/reducers";
import listReducers from "../../list/reducers";
import mobile from "./mobile";
import udo from "./udo";
import place from "./place";
import user from "./user";
import availability from "./availability";

const reducers = {
  resource(state = "") { return state; },
  kind(state = "") { return state; },
  udo,
  userAgent,
  mobile,
  place,
  availability,
  user,
  routing: routerReducer,
  ...poiReducers,
  ...listReducers,
};

export default combineReducers(reducers);



// WEBPACK FOOTER //
// ./assets/shared/reducers/index.js